/**
 * FAQ + JSON-LD FAQPage for the Brazil SEO landings.
 * The JSON-LD itself is emitted from the route head(); this component
 * renders the human-readable accordion.
 */
export interface FaqItem { q: string; a: string; }

export const BRASIL_FAQ_BY_CHANNEL: Record<string, FaqItem[]> = {
  cazetv: defaultFaq("CazéTV"),
  globo: defaultFaq("TV Globo"),
  sportv: defaultFaq("SporTV"),
  globoplay: defaultFaq("Globoplay"),
  "n-sports": defaultFaq("N Sports"),
  nsports: defaultFaq("N Sports"),
};

function defaultFaq(ch: string): FaqItem[] {
  return [
    { q: `O VerseSport é o canal oficial da ${ch}?`, a: `Não. O VerseSport não transmite nem redistribui sinal. Acompanhamos a transmissão da ${ch} que você já está assistindo, oferecendo estatísticas, previsões e segunda tela.` },
    { q: "Preciso pagar para usar?", a: "Não. A torcida brasileira no Mundial é grátis: previsões, Nation Wars e Audio Sync." },
    { q: "Funciona com qualquer transmissão?", a: "Sim. O Audio Sync funciona com CazéTV, Globo, SporTV, N Sports e Globoplay." },
    { q: "Como faço para subir no ranking?", a: "Acerte previsões, complete missões e convide amigos para a torcida." },
  ];
}

export function BrasilFaq({ items }: { items: FaqItem[] }) {
  return (
    <section aria-label="Perguntas frequentes" className="rounded-2xl border border-border bg-background/60 p-3">
      <h2 className="text-sm font-black">Perguntas frequentes</h2>
      <dl className="mt-2 space-y-2">
        {items.map((it) => (
          <div key={it.q}>
            <dt className="text-[12px] font-bold">{it.q}</dt>
            <dd className="text-[11px] text-muted-foreground">{it.a}</dd>
          </div>
        ))}
      </dl>
    </section>
  );
}

export function buildFaqJsonLd(items: FaqItem[]) {
  return {
    "@context": "https://schema.org",
    "@type": "FAQPage",
    mainEntity: items.map((it) => ({
      "@type": "Question",
      name: it.q,
      acceptedAnswer: { "@type": "Answer", text: it.a },
    })),
  };
}